import { Injectable, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { IParty } from '@tablesready/common-ui';
import { LabelsEnum } from '@shared/sms/enums';
import { Inbound, Notification } from '@shared/party/models';
import { MessageSenderService } from './message-sender.service';
import { ClockService } from '@tablesready/frontend-alerts-bar';

const msPerMin = 60000;

@Injectable()
export class MessageButtonService implements OnDestroy {
  private now = 0;
  private readonly subscription = new Subscription();

  constructor(
    private readonly clockService: ClockService,
    private readonly messageSenderService: MessageSenderService,
  ) {
    const clockSub = this.clockService.clock$
      .subscribe((now) => {
        this.now = now;
      });

    this.subscription.add(clockSub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  mergeInboundOutbound<T extends { notifications: Notification[]; inbounds: Inbound[] }>(party: T): Notification[] {
    const messages: Notification[] = [];
    const lastMessages = -4;

    if (party.notifications) {
      Array.prototype.push.apply(messages, party.notifications.slice(lastMessages));
    }
    if (party.inbounds) {
      Array.prototype.push.apply(messages, party.inbounds.slice(lastMessages));
    }
    messages.sort((a: Notification, b: Notification) => a.time - b.time);

    return messages.slice(lastMessages);
  }

  sendReadySms(party: IParty, smsNextMessage: string): void {
    this.messageSenderService.smsPage(party, smsNextMessage, LabelsEnum.ready);
  }

  disableMessageButton(party: IParty): boolean {
    if (!party.phone) {
      return true;
    }
    if (party.notifications?.[party.notifications.length - 1] === undefined) {
      return false;
    }
    // Disable if it's a ready message that was sent or is in process within last minute
    return (
      party.notifications[party.notifications.length - 1].label === LabelsEnum.ready &&
      ['inProcess', 'sent'].includes(party.notifications[party.notifications.length - 1].status_sent) &&
      party.notifications[party.notifications.length - 1].time >=
      this.now - msPerMin
    );
  }
}
